import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_RESOURCES_KEY } from '_api/queries/resource/useGetAllResources';

export const DELETE_RESOURCE_BY_ID_KEY = 'delete-resource-by-id';

export const useDeleteResourceById = () => {
  const queryClient = useQueryClient();

  return useApiMutation<{}, { id: number }>(
    ({ id }) => `/resource/${id}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_RESOURCE_BY_ID_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_RESOURCES_KEY] });
      },
    },
  );
};
